import { BitmapText, Container } from '@pixi/react'
import { gameConfig } from '../../config'
import { Container as PixiContainer, BitmapText as PixiBitmapText } from 'pixi.js'
import { useEffect, useMemo, useRef } from 'react'
import { godziDropService } from '../../domain/godziDrop/service/GodziDropService'

export const GodziDropWrapper = () => {
  const godziWrapperRef = useRef<PixiContainer>()
  const godziMultiplierRef = useRef<PixiBitmapText>()
  const godziPayoutRef = useRef<PixiBitmapText>()
  useEffect(() => {
    godziDropService.godziWrapper = godziWrapperRef.current as PixiContainer
    godziDropService.multiplierText = godziMultiplierRef.current as PixiBitmapText
    godziDropService.payoutText = godziPayoutRef.current as PixiBitmapText
  }, [])

  const godziDropWrapper = useMemo(() => {
    return (
      <Container
        eventMode="static"
        name="godziDropWrapper"
        ref={(el: PixiContainer | null) => {
          godziWrapperRef.current = el as PixiContainer
        }}
        scale={1.5}
      >
      </Container>
    )
  }, [])

  const godziMultiplier = useMemo(() => {
    return (
      <BitmapText
        key="godziMultiplierText"
        name="godziMultiplierText"
        style={{ fontName: 'GodziFont', fontSize: 26, align: 'center' }}
        anchor={[0.5, 2]}
        ref={(el: PixiBitmapText) => {
          godziMultiplierRef.current = el
        }}
      />
    )
  }, [])

  const godziPayout = useMemo(() => {
    return (
      <BitmapText
        key="godziPayoutText"
        name="godziPayoutText"
        style={{ fontName: 'GodziFont', fontSize: 26, align: 'center' }}
        anchor={[0.5, 2]}
        ref={(el: PixiBitmapText) => {
          godziPayoutRef.current = el
        }}
      />
    )
  }, [])

  return (
    <>
      <Container
        name="GodziSpineContainer"
        x={gameConfig.resolution.width / 2}
        y={gameConfig.resolution.height / 2}
      >
        {godziDropWrapper}
      </Container>

      <Container
        name="GodziMultiplierContainer"
        x={gameConfig.resolution.width / 2}
        y={1000}
        scale={1.5}
      >
        {godziMultiplier}

      </Container>

      <Container
        name="GodziPayoutContainer"
        x={gameConfig.resolution.width / 2}
        y={1000}
        scale={1.5}
      >
        {godziPayout}

      </Container>
    </>

  )
}
